import { defineComponent as n, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as h, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "a6425f5a-842f-4541-96ce-12b73471cf77" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#a6425f5a-842f-4541-96ce-12b73471cf77)" }, u = { key: 0 }, g = /* @__PURE__ */ p('<path fill="#333" d="M0 .4h512l-34 229H36z"></path><path fill="#ffda44" d="m367.3 205.3-109.7 19.4-112.9-19.4 45.5-21.3-24.2-44 49.3 9.4 6.3-49.9 34.4 36.7 34.4-36.6 6.3 50L346 140l-24.2 44z"></path><path fill="#0052b4" d="M25.6 205.3h466.8L257 439.5z"></path><path fill="#eee" d="M34 307.4h446L256 511.6z"></path><path fill="#a2001d" d="m0 511.6 256 .4L0 .4zm256 .4 256-.4V0z"></path>', 5), v = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ n({
  __name: "ag",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (z, w) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (s(), i("title", u, d(e.flagName), 1)) : f("", !0),
        g
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=ag-d0e9f970.js.map
